import { ref, toRefs } from 'vue';
import useActions from './actions';
import { defineStore } from 'pinia';
import useCommonGetters from '../common-getters';
import { INotificationState, MESSAGES_PAGE_SIZE, GROUPS_PAGE_SIZE } from './models';

export const useNotificationsStore = defineStore('notifications', () => {
  const state = ref(<INotificationState>{
    adminGroups: [],
    adminGroupsPagination: { page: 1, rowsPerPage: GROUPS_PAGE_SIZE, rowsNumber: 0 },
    activeAdminGroup: undefined,
    messages: [],
    messagesPagination: { page: 1, rowsPerPage: MESSAGES_PAGE_SIZE, rowsNumber: 0 },
    editGroup: undefined,
    isEditGroupDialogVisible: false,
    groupToDelete: undefined,
    isDeleteGroupDialogVisible: false,
    editMessage: undefined,
    isEditMessageDialogVisible: false,
  });

  return {
    ...toRefs(state.value),
    ...useCommonGetters<INotificationState>(state),
    ...useActions(state),
  };
});
